import { RendererProps } from "../components/widgets/types";

export const useIndicators = (props: RendererProps, isLoading: boolean, error: boolean) => {
  const { loadingIndicator, errorDisplay } = props;
  if (isLoading && loadingIndicator != null) {
    return loadingIndicator;
  }
  if (error) {
    return errorDisplay;
  }
  return null;
};
